export default function formatString(text) {
  if (!text) return '';
  const s = text.replace(/_/g, ' ');
  return s.slice(0, 1).toUpperCase() + s.slice(1);
}



// WEBPACK FOOTER //
// ./src/utils/formatString.js